import PostsAdapter from './base';

export default class Globalnotice extends PostsAdapter {
  namespace = 'posts/v4';
  modelNamePlural = 'globalnotices';
}
